import React from 'react';
import type { CampaignCard as CampaignCardStyles } from '../css/CampaignCard.modules';
import { CampaignCollapsibleControls } from '../../../shared/CampaignCollapsibleControls';

interface CampaignCardControlsProps {
  hasMany: boolean;
  arrow: string;
  isCollapsed: boolean;
  onArrowClick: () => void;
  campaignCardStyles: CampaignCardStyles;
}

const CampaignCardControls: React.FC<CampaignCardControlsProps> = ({ 
  hasMany, 
  arrow, 
  isCollapsed, 
  onArrowClick, 
  campaignCardStyles 
}) => (
  !hasMany ? (
    <CampaignCollapsibleControls
      hasMany={hasMany}
      arrow={arrow}
      isCollapsed={isCollapsed}
      onArrowClick={onArrowClick}
      swipeBlockClassName={campaignCardStyles.swipeBlock}
      arrowClassName={campaignCardStyles.arrow}
      arrowRotatedClassName={campaignCardStyles.rotated}
    />
  ) : null
);

export default CampaignCardControls;
